export const checkIE = () => {
  return navigator.userAgent.toLowerCase().indexOf('msie') !== -1;
};
